import { mapState, mapGetters, mapActions } from 'vuex';

import SharedHeader from '@/components/SharedHeader.vue';
import SharedFooter from '@/components/SharedFooter.vue';
import Spinner from '@/components/Spinner.vue';
import { RE_EMAIL } from '@/constants/index';
import { PASSWORD_CONFIRM_PAGE } from '@/constants/routes';
import { CaptchaMixin } from '../Mixin';
import { LOADING_MESSAGE } from './Forget.constants';

export default {
  name: 'Forget',

  mixins: [CaptchaMixin],

  components: {
    SharedHeader,
    SharedFooter,
    Spinner,
  },

  data: () => {
    return {
      loadingMessage: LOADING_MESSAGE,
      email: '',
      reEmail: RE_EMAIL,
      objError: {
        email: {
          pristine: true,
          invalid: false,
        },
        failed: false,
      },
    };
  },

  computed: {
    ...mapState('Password/Forget', {
      ms_message: 'message',
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters({
      immLoading: 'immLoading',
    }),

    c_isEmailReady() {
      return !this.objError.email.invalid && !this.objError.email.pristine;
    },

    c_isSubmitDisabled() {
      return !this.c_isEmailReady || !this.c_isCaptchaReady;
    },
  },

  methods: {
    ...mapActions('Password/Forget', {
      ma_passwordForget: 'passwordForget',
    }),

    handleChangeEmail() {
      this.objError.failed = false;
      this.objError.email.invalid = false;
      if ('' === this.email) {
        this.objError.email.pristine = true;
      } else {
        this.objError.email.pristine = false;
        const isEmailValid = this.reEmail.test(this.email);
        if (!isEmailValid) {
          this.objError.email.invalid = true;
        }
      }
    },

    beforeHandleChangeCaptcha() {
      this.objError.failed = false;
    },

    async next() {
      const res = await this.ma_passwordForget({
        email: this.email.toLowerCase(),
        captcha: this.captcha,
      });
      if (res.data.status == 200) {
        this.$router.push(PASSWORD_CONFIRM_PAGE);
      } else {
        this.objError.failed = true;
        if (res.data.status == -2) {
          this.objError.captchaError = true;
          this.refresh();
        }
      }
    },
  },
};
